import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleJobRate } from '../../../Store/PHPSlice/JobRate';


const TableBody = ({
    id,
    dt,
    itemNm,
    itemId,
    stitch_in,
    stitch_out,
    kaje_in,
    kaje_out,
    press_in,
    press_out,
    material,
    extra,
    total,
    cut_in,
    cut_out,
    embriadary,
    print,
    screen,
    stitch_to_pack,
    cut_to_pack,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();


    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Job Rate?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleJobRate(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast.success("Job Rate Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };





    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{dt}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{itemNm}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{cut_in}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{cut_out}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{stitch_in}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{stitch_out}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{kaje_in}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{kaje_out}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{press_in}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{press_out}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{embriadary}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{screen}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{print}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{extra}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{material}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{total}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{cut_to_pack}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{stitch_to_pack}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
